// Uploaded import/export files are deleted by a scheduled cleanup job after a
// retention window, but the change-history record keeps its "Import" link
// forever — so an old link 404s. This strips the anchor (leaving plain
// "Import" text) once the referenced file is past retention, so users never
// click a dead link.

const RETENTION_DAYS = 180;

// No upload files exist before this date on the current server: everything
// earlier was purged under the previous 5-day retention and can't come back.
// Until (now - RETENTION_DAYS) passes this date, it is the effective floor;
// afterward it is harmless and the plain 180-day window governs.
const UPLOADS_EPOCH = Date.parse('2026-07-18T00:00:00Z');

// Parse the timestamp a filename carries (e.g. 2026-07-10T03-01-56 or
// adem-export-2026-07-17T18-56-15_1) into epoch ms, or NaN if none.
function fileTimestamp(filename: string): number {
  const m = filename.match(/(\d{4}-\d{2}-\d{2})T(\d{2})-(\d{2})-(\d{2})/);
  if (!m) { return NaN; }
  return Date.parse(`${m[1]}T${m[2]}:${m[3]}:${m[4]}Z`);
}

function fileStillExists(filename: string): boolean {
  const ts = fileTimestamp(filename);
  if (isNaN(ts)) { return false; }
  const floor = Math.max(Date.now() - RETENTION_DAYS * 86400000, UPLOADS_EPOCH);
  return ts >= floor;
}

// Given a stored update_method / notes value (which may embed an <a> link to a
// /uploads/ file), return HTML with the link kept only if its file still
// exists; otherwise the anchor is replaced by its plain text.
export function renderUpdateMethod(value: any): string {
  const raw = String(value ?? '');
  if (!raw.includes('<a')) { return raw; }
  return raw.replace(
    /<a\b[^>]*href="[^"]*\/uploads\/([^"?#]+)[^"]*"[^>]*>(.*?)<\/a>/gi,
    (whole, filename, text) => (fileStillExists(filename) ? whole : text)
  );
}
